

<template>
  <div   class="card card-body card-procces-id-main-box mb-5 border-0">
    <div class="row d-flex justify-content-start">
      <h3 style="font-size: 1.2vw !important;">مشخصات فعاليت‏‌های فرآيند</h3>
    </div>

    <div class="table-responsive">
      <center v-show="!all_items.length">
        مشخصات فعالیت های فرآیند وجود ندارد
      </center>
      <table v-show="all_items.length" class="table table-striped" style="width: 70vw;">
        <thead>
        <tr>
          <th>ردیف</th>
          <th style="width: 15vw;">عنوان فعالیت</th>
          <th>سمت متولی</th>
          <th>نام متولی</th>
          <th style="width: 3vw ;">آیا مکانیزه است؟</th>
          <th style="width: 7vw;">متوسط زمان اجرا(دقیقه)</th>
          <th style="width: 7vw;">تواتر اجرا</th>
          <th style="width: 7vw;">محاسبات  </th>

          <th style="width: 6vw;">عملیات</th>
        </tr>
        </thead>
        <tbody>

        <tr v-for="(item,index) in all_items" :id="`item_${item.id}`">
          <td scope="row">{{index+1}}</td>

          <td>{{item.title}}</td>
          <td>
            <span @click="allUsersMethod(item.id)" style="color: #0d6efd; cursor: pointer;">مشاهده</span>
          </td>
          <td>
            <span @click="allUsersMethodTwo(item.id)" style="color: #0d6efd; cursor: pointer;">مشاهده</span>
          </td>
          <td style="width: 4vw;">{{item.mechanic}}</td>
          <td style="width: 4vw;">{{item.frequency}}</td>
          <td style="width: 4vw;">{{item.average_time}}</td>
          <td>{{!(parseInt(item.average_time) * parseInt(item.frequency)) ? 0 : parseInt(item.average_time) * parseInt(item.frequency)}}</td>

          <td>
            <div class="d-flex justify-content-evenly w-100">
              <p style="width: 2vw;" @click.prevent="deleteModalMethod(item.id)" href="#"><img class="table-delete-img mx-2" src="/img/delete.f9fc94bc.svg" alt="delete"> </p>
              <a  style="width: 2vw; transform: translateX(-0.2vw)" @click.prevent="edit(item.id)" href="#"><img class="table-edit-img" src="/img/pen.6428fd02.svg" alt="edit"></a>

            </div>
          </td>
        </tr>

        </tbody>
      </table>
    </div>
  </div>
<!-- ************************************** -->
  <div dir="rtl" class="modal__error slide-top" v-show="select_inserter"
       style="z-index: 999999999999999999999999999999999999999999999; top: 28%;">
    <div>
      <p>مسئول اجرا    </p>
      <p @click="select_inserter=!select_inserter">❌</p>
    </div>
    <div>
      <input v-model="search_inserter" class="form-control mb-3" type="text"
             placeholder="جستجو بر اساس کد و پست سازمانی...">
      <table class="table table-striped">
        <thead>
        <tr>
          <th style="width: 1vw;">انتخاب</th>
          <th>کد</th>
          <th>عنوان</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in filteredorganization" :key="item.id">
          <td scope="row"><input v-model="inserterId" type="radio" name="parent" :value="item['id']"></td>
          <td>{{ item['id'] }}</td>
          <td>{{ item['name'] }}</td>
        </tr>

        </tbody>
      </table>
      <button @click="select_inserterMethod">تایید</button>
    </div>
  </div>

  <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" style="z-index: 999999999999999; top: 28%;">
    <div>
      <p>حذف</p>
      <p @click="deleteModal=!deleteModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteItemForm(item_id)">تایید</button>
      </div>
    </div>
  </div>
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="allUserModal"
       style="z-index: 999999999999999999999999999999999999999999999; top: 38%;">
    <div>
      <p>   متولی  </p>
      <p @click="allUserModal=!allUserModal">❌</p>
    </div>
    <div>
      <table class="table table-striped">
        <thead>
        <tr>
          <th>ردیف</th>
          <th>پست سازمانی</th>
          <th>نام و نام خانوادگی</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in allUser" :key="item.id">
          <td>{{ index+1 }}</td>
          <td>{{ item.organizationposts.name }}</td>
          <td>{{ item.organizationposts.curator.fullname }}</td>
        </tr>

        </tbody>
      </table>



      <button @click="allUserModal=!allUserModal">بازگشت</button>
    </div>
  </div>
  <!-- modal -->
  <div dir="rtl" class="modal__error slide-top" v-show="error"
       style="z-index: 999999999999999999999999999999999999999999999; top: 28%;">
    <div>
      <p>   خطا  </p>
      <p @click="error=!error">❌</p>
    </div>
    <div>
      {{errorMessage}}



      <button @click="error=!error">بازگشت</button>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="allUserModalTwo"
       style="z-index: 999999999999999999999999999999999999999999999; top: 38%;">
    <div>
      <p>   متولی  </p>
      <p @click="allUserModalTwo=!allUserModalTwo">❌</p>
    </div>
    <div>
      <table class="table table-striped">
        <thead>
        <tr>
          <th>ردیف</th>
          <th>نام و نام خانوادگی  </th>

        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in allUserTwo" :key="item.id">
          <td>{{ index+1 }}</td>
          <td>{{ item.user.fullname }}</td>

        </tr>

        </tbody>
      </table>



      <button @click="allUserModalTwo=!allUserModalTwo">بازگشت</button>
    </div>
  </div>
</template>
<script>
import {mapMutations, mapState} from "vuex";
import {all} from "core-js/internals/document-all";

export default {
  props: ['id_route', 'type'],
  data() {
    return {
      all_items: [],
      allUser: [],
      allUserTwo: [],
      all_inserter: [],
      select_inserter: false,
      allUserModal: false,
      allUserModalTwo: false,
      deleteModal: false,
      editModal: false,
      search_inserter: '',
      inserterId: '',
      title: '',
      inserterName: '',
      type: '',
      time: '',
      frequency: '',
      prerequisite: '',
      item_id: '',
      supplier: 1,
      error: false,
      errorMessage: false,

    }
  },


  methods: {
    allUsersMethodTwo(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();



      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/tasks_process/show_users/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.all){
              this.allUserTwo.length=0
              response.all.forEach((item)=>{
                this.allUserTwo.push(item)
              })
              this.allUserModalTwo = true
            }




          })
          .catch();
    },
    allUsersMethod(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();



      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/tasks_process/show_or/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.all){
              this.allUser.length=0
              response.all.forEach((item)=>{
                this.allUser.push(item)
              })
              this.allUserModal = true
            }




          })
          .catch();
    },
    deleteModalMethod(id){
      this.item_id=id
      this.deleteModal=true
    },
    deleteItemForm(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();



      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/tasks_process/destroy/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.error = true

              this.errorMessage = response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              return;
            }
            this.showItem()
            this.deleteModal=false


          })
          .catch();
    },
    edit(id){
      this.item_id=id
      this.editModal=true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();



      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/tasks_process/edit/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.error = true

              this.errorMessage = response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              return;
            }
            const item = response.item
            if (item){
              this.title=item.title
              this.time=item.average_time
              this.frequency=item.frequency
              this.prerequisite=item.prerequisite
              this.inserterName=item.organizationpost.name
              this.inserterId=item.organizationpost.id

            }




          })
          .catch();
    },
    update(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();
      formdata.append('organizationposts_id', this.inserterId)
      formdata.append('processes_id', this.id_route)
      formdata.append('title', this.title)
      formdata.append('average_time', this.time)
      formdata.append('frequency', this.frequency)
      formdata.append('prerequisite', this.prerequisite)

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/tasks_process/update/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.error = true

              this.errorMessage = response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              return;
            }
            this.showItem()
            this.inserterId=''
            this.title=''
            this.inserterName=''
            this.editModal=false
            this.title= ''
            this.time= ''
            this.frequency= ''
            this.prerequisite= ''
            this.inserterName= ''
            this.inserterId= ''



          })
          .catch();
    },
    saveItem() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();

      formdata.append('organizationposts_id', this.inserterId)
      formdata.append('processes_id', this.id_route)
      formdata.append('title', this.title)
      formdata.append('average_time', this.time)
      formdata.append('frequency', this.frequency)
      formdata.append('prerequisite', this.prerequisite)



      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/tasks_process/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.error = true

              this.errorMessage = response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              return;
            }
            this.addToSharedList()
            this.showItem()
            this.inserterId=''
            this.title=''
            this.inserterName=''
            this.title= ''
            this.time= ''
            this.frequency= ''
            this.prerequisite= ''
            this.inserterName= ''
            this.inserterId= ''

          })
          .catch();

    },
    getInformations() {
      fetch(`${this.base_url}/processes/information_by_id/${this.id_route}`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',

        },
        body: JSON.stringify({
          'type': 'next',
        })
      })
          .then(response => response.json())
          .then((response) => {
            if (response) {
              if (response.item) {
                this.type = response.item.type

              }

            }

          }).catch((err) => {
      })
    },
    // *************************************************
    // *************************************************
    // *************************************************
    ...mapMutations(['setSharedList']),
    addToSharedList() {
      this.setSharedList(true);

    },
    showListInserter() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/organization/post/all`, requestOptions)
          .then(response => response.json())
          .then(result => {
            this.all_inserter.length = 0

            if (result['all'].length !== 0) {
              result['all'].forEach(item => {
                this.all_inserter.push(item)
                this.select_inserter = true

              })

            }

          })
          .catch();
    },
    showItem() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/tasks_process/all/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.all){
              this.all_items.length=0
              response.all.forEach((item)=>{
                this.all_items.push(item)
              })

            }


          })
          .catch();

    },
    select_inserterMethod() {
      this.all_inserter.forEach((ele) => {
        ele.id === this.inserterId ? this.inserterName = ele.name : ''
      })
      this.select_inserter = false


    },


  },
  computed: {
    all() {
      return all
    },
    ...mapState(['statusInformation']),
    filteredorganization() {
      return this.all_inserter.filter(item => {
        return (
            item['name'].includes(this.search_inserter) ||
            item['id'].toString().includes(this.search_inserter)
        );
      });
    },
  },
  mounted() {
    this.getInformations()
    this.showItem()
  }

}

</script>
<style scoped>
.table-striped > tbody > tr:nth-of-type(odd) {
  --bs-table-accent-bg: #D0E9FA57;
  color: var(--bs-table-striped-color);
}
</style>